import { Chapter, Reveal } from "../presentation";

export default function S13Thanks() {
  return (
    <section id="thanks" className="closing" data-testid="slide-thanks">
      <div className="closing-inner">
        <div className="closing-top">
          <Chapter ch="10" label="sunreef — cannes 2026" testid="thanks-chapter" />
        </div>

        <div className="closing-body">
          <Reveal delay={1}>
            <h2 className="cover-wordmark closing-wordmark" data-testid="thanks-wordmark">SUNREEF</h2>
          </Reveal>
          <Reveal delay={2}>
            <p className="closing-tagline" data-testid="thanks-tagline">
              Life in full
            </p>
          </Reveal>
        </div>

        <div className="closing-foot" data-testid="thanks-foot">
          <a
            href="https://sunreef-yachts.com"
            target="_blank"
            rel="noopener noreferrer"
            className="closing-foot-link"
            data-testid="thanks-foot-link"
          >sunreef-yachts.com</a>
          <span> · Gdańsk — UAE · Cannes 2026</span>
        </div>
      </div>
    </section>
  );
}
